<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="确认"
    :title="title"
    :cancel-show="false"
    width="50%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div
      v-if="item.title"
      class="title"
    >
      {{ item.title }}
    </div>
    <videoPlayer
      ref="videoPlayer"
      :options="playerOptions"
    />
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';

export default {
  name: 'VideoDialog',
  components: { customeDialog, videoPlayer },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '考试视频',
      cancelText: '取消',
      courseList: [],
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: {
          type: '',
          src: '', // url地址
        },
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: true, // 是否显示剩余时间功能
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          console.log(this.item);
          if (this.item.url) {
            this.$refs.videoPlayer.player.reset(); // 重置 video
            this.$refs.videoPlayer.player.src(this.item.url);
            this.$refs.videoPlayer.player.load();
            this.$refs.videoPlayer.player.play();
          }
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$refs.videoPlayer.player.pause();
      this.$emit('close');
    },
    confirm() {
      this.$emit('update:dialogVisible', false);
      this.$refs.videoPlayer.player.pause();
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
.title{
  display: flex;
  padding-bottom: 5px;
  justify-content: center;
  font-size: 22px;
  color: $--base-color-main;
}
.video-player{
 ::v-deep .vjs-big-play-button{
    left: 0;
    right: 0;
    bottom: 0;
    top:0;
    margin: auto;
  }
}
</style>
